"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueFileName = void 0;
var uuid_1 = require("uuid");
var uniqueFileName = function (name, uniqueId) {
    var chunks = name.replace(/[\W_]+/g, " ").split(" ");
    var extension = (chunks || []).pop();
    return (uniqueId
        ? uniqueId + "-" + (0, uuid_1.v4)() + "." + extension
        : chunks.join("-") + "-" + (0, uuid_1.v4)() + "." + extension).toLowerCase();
};
exports.uniqueFileName = uniqueFileName;
